module.exports = __webpack_public_path__ + "img/lideranca_bronze.b6a61f37.png";